
// dp
import partnerIndex from '@/views/smartLife/partner/index'

const dpRoutes = Array.from({ length: 24 }, (_, i) => ({
  path: `partner/dp/index${i + 1}`,
  name: `partner/dp/Index${i + 1}`,
  component: () => import(`@/views/smartLife/partner/dp/index${i + 1}.vue`)
}))
const branch1DpRoutes = Array.from({ length: 20 }, (_, i) => ({
  path: `partner/dp/branch1/index${i + 1}`,
  name: `partner/dp/branch1/Index${i + 1}`,
  component: () => import(`@/views/smartLife/partner/dp/branch1/index${i + 1}.vue`)
}))
const branch2DpRoutes = Array.from({ length: 20 }, (_, i) => ({
  path: `partner/dp/branch2/index${i + 1}`,
  name: `partner/dp/branch2/Index${i + 1}`,
  component: () => import(`@/views/smartLife/partner/dp/branch2/index${i + 1}.vue`)
}))

// db
const dbRoutes = Array.from({ length: 23 }, (_, i) => ({
  path: `partner/db/index${i + 1}`,
  name: `partner/db/Index${i + 1}`,
  component: () => import(`@/views/smartLife/partner/db/index${i + 1}.vue`)
}))
const branch1DbRoutes = Array.from({ length: 17 }, (_, i) => ({
  path: `partner/db/branch1/index${i + 1}`,
  name: `partner/db/branch1/Index${i + 1}`,
  component: () => import(`@/views/smartLife/partner/db/branch1/index${i + 1}.vue`)
}))
// const branch2DbRoutes = Array.from({ length: 12 }, (_, i) => ({
//   path: `partner/db/branch2/index${i + 1}`,
//   name: `partner/db/branch2/Index${i + 1}`,
//   component: () => import(`@/views/smartLife/partner/db/branch2/index${i + 1}.vue`)
// }))
// const branch3DbRoutes = Array.from({ length: 10 }, (_, i) => ({
//   path: `partner/db/branch3/index${i + 1}`,
//   name: `partner/db/branch3/Index${i + 1}`,
//   component: () => import(`@/views/smartLife/partner/db/branch3/index${i + 1}.vue`)
// }))
// const branch4DbRoutes = Array.from({ length: 14 }, (_, i) => ({
//   path: `partner/db/branch4/index${i + 1}`,
//   name: `partner/db/branch4/Index${i + 1}`,
//   component: () => import(`@/views/smartLife/partner/db/branch4/index${i + 1}.vue`)
// }))

const xfRoutes = Array.from({ length: 30 }, (_, i) => ({
  path: `partner/xf/index${i + 1}`,
  name: `partner/xf/Index${i + 1}`,
  component: () => import(`@/views/smartLife/partner/xf/index${i + 1}.vue`)
}))
const branchXfRoutes = Array.from({ length: 20 }, (_, i) => ({
  path: `partner/xf/branch1/index${i + 1}`,
  name: `partner/xf/branch1/Index${i + 1}`,
  component: () => import(`@/views/smartLife/partner/xf/branch1/index${i + 1}.vue`)
}))

export default {
  path: '/smartLife',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'partner/index',
      name: 'partnerIndex',
      component: partnerIndex
    },
    ...dpRoutes,
    ...branch1DpRoutes,
    ...branch2DpRoutes,
    ...dbRoutes,
    ...branch1DbRoutes,
    // ...branch2DbRoutes,
    // ...branch3DbRoutes,
    // ...branch4DbRoutes,

    ...xfRoutes,
    ...branchXfRoutes

  ]
}
